import styled from 'styled-components';

import { Text } from 'shared/components/Text/Text';

export const AccountBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const AccountBodyHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  margin-top: 8px;
  margin-bottom: 48px;

  img {
    width: 71px;
    height: 77px;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
      width: 81px;
      height: 87px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    gap: 24px;
    margin-top: 16px;
    margin-bottom: 56px;
  }
`;

export const NameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

export const Name = styled(Text)`
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    font-size: 24px;
  }
`;

export const AgreementNumber = styled(Text)`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 8px;
  width: 100%;
`;

export const ItemButton = styled.button`
  display: flex;
  align-items: center;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 16px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.cardElevationMidWhite};

  ${TextContainer} svg path {
    fill: ${({ theme }) => theme.colors.iconIconPrimarySecondary1100};
  }

  &:hover {
    background: ${({ theme }) => theme.colors.cardInteractionHoverGrey05};

    ${TextContainer} svg path {
      fill: ${({ theme }) => theme.colors.iconIconPrimaryHoverFunction4100};
    }
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.cardInteractionActiveSecondary420};
    ${TextContainer} svg path {
      fill: ${({ theme }) => theme.colors.iconIconPrimaryPressedSecondary2100};
    }
  }

  &:focus {
    border-radius: 3px;
    border: 3px solid ${({ theme }) => theme.colors.chartChartLightbluePressedSecondary240};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    padding: 16px 20px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    padding: 16px 40px;
  }
`;

export const ListText = styled(Text)`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
`;

export const LogoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: auto 16px 0 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    margin: auto 24px 0 24px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    margin: auto 40px 0;
  }
`;
